/* Scrollspy til Viden-artiklernes sticky indholdsfortegnelse.

   Markerer det afsnit, læseren er nået til, med .is-active på det tilsvarende link.

   TIDSPUNKTET FOR SKIFTET er rullet tilbage til den oprindelige udgave: læselinjen
   ligger ved overskrifternes scroll-margin-top plus 8px. Mellemliggende forsøg med
   linjen 45% nede i vinduet gjorde det værre og er droppet. Skal timingen justeres
   igen, er det dette ene tal i readLine() — større værdi = skifter tidligere.

   HVORFOR IntersectionObserver OG IKKE SCROLL-EVENTS:
   Det er den ene ting, der IKKE er rullet tilbage, og det er ikke en smagssag.
   Temaet lader ikke scroll-events nå frem til lyttere tilføjet på window — målt til
   nul events under en fuld gennemscrollning, mens window.scrollY samtidig ændrede sig
   som normalt. Den oprindelige, scroll-event-baserede udgave kørte derfor kun én gang
   ved indlæsning og sad fast på første punkt hele vejen ned. Observeren er blot
   signalet om at noget har krydset linjen; hvilket afsnit der er det aktuelle,
   afgøres af positionerne som før. Skiftet er altså usynligt — adfærden er den
   oprindelige, den bliver bare rent faktisk udløst nu. */
(function () {
  var toc = document.querySelector('.pd-viden > .pd-toc');
  if (!toc) return;

  var entries = [];
  Array.prototype.forEach.call(toc.querySelectorAll('a[href^="#"]'), function (link) {
    var id = decodeURIComponent(link.getAttribute('href').slice(1));
    var target = id && document.getElementById(id);
    if (target) entries.push({ link: link, target: target });
  });
  if (!entries.length) return;

  var active = null;
  var ticking = false;
  var observer = null;

  function readOffset() {
    var offset = parseInt(getComputedStyle(toc).getPropertyValue('--pd-viden-offset'), 10);
    return isNaN(offset) ? 240 : offset;
  }

  function update() {
    ticking = false;
    var line = readOffset() + 8;
    var current = entries[0].link;

    for (var i = 0; i < entries.length; i++) {
      if (entries[i].target.getBoundingClientRect().top <= line) {
        current = entries[i].link;
      }
    }

    // Nederst på siden når de sidste afsnit ikke nødvendigvis op over læselinjen,
    // så markér det sidste punkt når der ikke er mere at scrolle.
    if (window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 2) {
      current = entries[entries.length - 1].link;
    }

    if (current === active) return;
    if (active) active.classList.remove('is-active');
    current.classList.add('is-active');
    active = current;
  }

  function schedule() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  }

  function observe() {
    if (observer) observer.disconnect();

    // Roden beskæres foroven til læselinjen, så observeren kalder tilbage netop når
    // en overskrift krydser den. rootMargin kan ikke ændres på en eksisterende
    // observer, så den bygges forfra hvis linjen flytter sig (fx ved resize).
    observer = new IntersectionObserver(schedule, {
      rootMargin: -(readOffset() + 8) + 'px 0px 0px 0px',
      threshold: 0
    });

    for (var i = 0; i < entries.length; i++) {
      observer.observe(entries[i].target);
    }
  }

  observe();
  update();

  window.addEventListener('resize', function () {
    observe();
    schedule();
  }, { passive: true });

  // Sele og seler: når scroll-events mod forventning når frem, koster det ingenting
  // at lytte med. Capture-fasen bruges, fordi en lytter i bobble-fasen kan blive
  // stoppet af andre handlere undervejs.
  window.addEventListener('scroll', schedule, { passive: true, capture: true });
})();
